<template>
  <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
    <slot />
  </transition>
</template>

<style lang="scss" scoped>
* {
  backface-visibility: hidden;
}
.expand-enter-active,
.expand-leave-active {
  transition: 0.35s ease-in-out;
  overflow: hidden;
  transition-property:
    opacity, height, margin-top, margin-bottom, padding-bottom, padding-top, border-top-width,
    border-bottom-width;
}
.expand-enter-from,
.expand-leave-to {
  height: 0;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  border-top-width: 0 !important;
  border-bottom-width: 0 !important;
  opacity: 0;
}
</style>

<script>
export default {
  name: 'AnimatedHeight',
  methods: {
    enter(element) {
      const width = getComputedStyle(element).width;
      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';
      const height = getComputedStyle(element).height;
      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;
      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;
      // Trigger the animation.
      // We use `requestAnimationFrame` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    leave(element) {
      const height = getComputedStyle(element).height;
      element.style.height = height;
      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>
